<template>
  <div class="enroll-student-upload">
    <div class="header">
      <div class="title">录取照片上传</div>
    </div>
    <div class="main">
      <div class="main-cont">
        <EnrollStudentUploadMain></EnrollStudentUploadMain>
      </div>
    </div>
  </div>
</template>

<script>
import EnrollStudentUploadMain from './main'
export default {
  name: 'EnrollStudentUpload',
  components: {
    EnrollStudentUploadMain
  }
}
</script>

<style lang="scss">
  .enroll-student-upload {
    height: 100%;
    display: flex;
    flex-direction: column;
    & > .header {
      flex: none;
      & > .title {
        font-size: 13px;
        text-align: center;
        background-color: #fff;
        padding: 12px 15px;
        border-bottom: 1px solid #ebeef5;
        box-sizing: border-box;
      }
    }
    & > .main {
      flex: auto;
      background-color: #fff;
      position: relative;
      & > .main-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }
    }
  }
</style>
